export const columnDef = [
    {
        headerName: "",
        field: "Id",
        cellRenderer: "Info",
        width: 60,
    },
    {
        field: "Name",
        headerName: "Name",
        flex: 1,
        minWidth: 200,
    },
    {
        field: "Description",
        headerName: "Description",
        flex: 1,
        minWidth: 250,
    },
    {
        field: "DefaultUnitType",
        headerName: "Default Unit Type",
        flex: 1,
        minWidth: 150,
    },
    {
        field: "IsActive",
        headerName: "Status",
        flex: 1,
        minWidth: 120,
        cellRenderer: "StatusCellRenderer",
    },
];
